import { render, staticRenderFns } from "./MemedEmbed.vue?vue&type=template&id=4a5fa1fa&scoped=true"
import script from "./MemedEmbed.vue?vue&type=script&lang=js"
export * from "./MemedEmbed.vue?vue&type=script&lang=js"
import style0 from "./MemedEmbed.vue?vue&type=style&index=0&id=4a5fa1fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5fa1fa",
  null
  
)

export default component.exports